import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M14.768 5.039a3.944 3.944 0 0 0-5.536 0 3.833 3.833 0 0 0 0 5.46 3.944 3.944 0 0 0 5.536 0 3.833 3.833 0 0 0 0-5.46Zm-6.521-.995a5.344 5.344 0 0 1 7.506 0 5.233 5.233 0 0 1 0 7.45 5.344 5.344 0 0 1-7.506 0 5.233 5.233 0 0 1 0-7.45Zm-.858 11.974c-1.657 0-2.989 1.328-2.989 2.952v1.826a.7.7 0 1 1-1.4 0V18.97c0-2.41 1.972-4.352 4.389-4.352H17.61a.7.7 0 1 1 0 1.4H7.39Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M20.308 12.3a.7.7 0 0 1 .495.205l2.227 2.226a.7.7 0 0 1 0 .99l-6.01 6.01a.7.7 0 0 1-.412.2l-2.526.299a.7.7 0 0 1-.777-.778l.299-2.525a.7.7 0 0 1 .2-.413l6.01-6.009a.7.7 0 0 1 .494-.205Zm-5.342 7.033-.166 1.402 1.402-.166 5.343-5.342-1.237-1.237-5.342 5.343Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
